<template>
  <video
    ref="player"
    controls
    :poster="poster"
    :autoplay="autoplay"
    :preload="preload"
    disablepictureinpicture
    disableremoteplayback
    oncontextmenu="return false;"
    playsinline
    v-bind="$attrs"
  >
    <source
      :src="src"
      :type="type"
    >
    {{ __('components.video-player.not-supported') }}
  </video>
</template>

<script>
export default {
  props: {
    src: { type: String, required: true },
    plyr: { type: Boolean, default: false },
    autoplay: { type: Boolean, default: true },
    poster: { type: String, default: null },
    preload: {
      type: String,
      default: (props) => props.poster ? 'metadata' : 'auto',
    },
  },

  data() {
    return {
      player: null,
      type: null,
    };
  },

  mounted() {
    const parts = this.src.split('/');

    if (!parts[parts.length -1].includes('.') || parts[parts.length -1].endsWith('.mov')) {
      this.type = 'video/mp4';
    } else if (parts[parts.length -1].endsWith('.quicktime') && this.$page?.props?.isIos) {
      this.type = 'video/quicktime';
    }

    if (this.$refs.player) {
      this.$refs.player.pause();
    }

    if (this.plyr) {
      import('plyr').then(({ default: Plyr }) => {
        this.$nextTick(() => {
          this.player = new Plyr(this.$refs.player, {
            controls: ['play-large', 'mute'],
          });
        });
      });
    }
  },

  beforeUnmount() {
    if (this.player) {
      this.player.destroy();
    }
  },
};
</script>
